if (Foundation.MOBILE) {
    /** @implements {Foundation.View.Interface.ErrorList} */
    Foundation.View.ErrorList = Foundation.View.Mobile.ErrorList;
}
else {
    /** @implements {Foundation.View.Interface.ErrorList} */
    Foundation.View.ErrorList = Foundation.View.Desktop.ErrorList;
}

